import { describeWindowClients } from 'serviceWorker/helpers/windowClients';
import { swLog } from 'serviceWorker/helpers/makeSwLogger';
import { isChannelRequestNotAcknowledged } from 'shared/channels';
import { tokenClient } from 'shared/domain/auth/tokenClient';
import type { TokenAnswer } from 'shared/domain/auth/tokenModel';
import { LogLevel } from 'shared/types/logger';

/**
 * A token from an open page through the token contract. When no page serves
 * it (no tab open, or none answering) the request rejects as not
 * acknowledged; the log tells which window clients there were.
 */
export async function requestTokenFromPage(): Promise<TokenAnswer> {
  try {
    return await tokenClient.requestToken();
  } catch (error) {
    if (isChannelRequestNotAcknowledged(error)) {
      swLog('SW token request: no page answered', LogLevel.INFO, error, {
        setup: await describeWindowClients(),
      });
    }
    throw error;
  }
}
